"use client";

import { useMemo, useState } from "react";
import type { RowData } from "@tanstack/react-table";
import type { RecordDataSource } from "../types";

interface HeldRows<TData> {
  objectId: string;
  rows: TData[];
}

export function useHeldRows<TData extends RowData>(
  objectId: string,
  data: RecordDataSource<TData>,
) {
  const [held, setHeld] = useState<HeldRows<TData>>({ objectId, rows: data.rows });
  const waiting = Boolean(data.isLoading) && data.rows.length === 0;
  if (!waiting && (held.rows !== data.rows || held.objectId !== objectId)) {
    setHeld({ objectId, rows: data.rows });
  }
  const isStale = waiting && held.objectId === objectId && held.rows.length > 0;
  const source = useMemo(
    () => (isStale ? { ...data, rows: held.rows } : data),
    [data, held.rows, isStale],
  );
  return { data: source, isStale };
}
